import { headers } from './requestConfig';
import { home } from '../service/links';

export const getHomeData = async () => {
  try {
    return await fetch(home, {
      method: 'GET',
      headers,
      credentials: 'include',
    });
  } catch {
    return null;
  }
};
